<template>
    <div class="app-body">
        <div class="a-flex-rsbc">
            <bread-crumb></bread-crumb>
        </div>
        <el-card class="el-main" v-loading="loading">
            <!-- 内容区域 -->
            <div class="content-area">
                <!-- 处理中 -->
                <div v-if="detail.status === 0" class="status-tip">
                    <i class="el-icon-loading"></i>
                    <span>AI分析报告生成中，请稍后...</span>
                </div>

                <!-- 失败 -->
                <div v-else-if="detail.status === 2" class="status-tip error">
                    <i class="el-icon-warning"></i>
                    <span>报告生成失败{{ detail.errorMsg ? '：' + detail.errorMsg : '' }}</span>
                </div>

                <!-- 成功 - markdown内容 -->
                <div v-else-if="detail.status === 1" class="markdown-body" v-html="renderedMarkdown" @click="handleMarkdownClick"></div>

                <!-- 无数据 -->
                <div v-else class="status-tip">
                    <span>暂无数据</span>
                </div>

                <le-preview-img v-model="showPreviewImg" :imgList="previewList" :showIndex="showIndex"></le-preview-img>
            </div>
            <div style="min-height: 100px"></div>
        </el-card>
        <div class="a-line-t-e0 footerBox">
            <el-button class="a-ml-24 a-mt-15" @click="cancelSubmit">返回</el-button>
        </div>
    </div>
</template>

<script>
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt()

export default {
    data () {
        return {
            id: '',
            detail: {},
            loading: false,
            showPreviewImg: false,
            previewList: [],
            showIndex: 0
        }
    },
    computed: {
        statusText () {
            const map = { 0: '处理中', 1: '成功', 2: '失败' }
            return map[this.detail.status] || '-'
        },
        statusClass () {
            const map = { 0: 'status-processing', 1: 'status-success', 2: 'status-error' }
            return map[this.detail.status] || ''
        },
        renderedMarkdown () {
            if (this.detail.summarize) {
                return md.render(this.detail.summarize)
            }
            return ''
        }
    },
    mounted () {
        this.id = this.$route.query.id
        if (this.id) {
            this.getDetail()
        }
    },
    methods: {
        // 查询AI分析报告详情
        getDetail () {
            this.loading = true
            this.$Axios._get({
                url: this.$Config.apiUrl.inspectionAiReport,
                params: {
                    patrolId: this.id
                }
            }).then(res => {
                this.loading = false
                if (res.result.code == 0) {
                    this.detail = res.result.data || {}
                } else {
                    this.$message.error(res.result.message)
                }
            }).catch(() => {
                this.loading = false
            })
        },
        cancelSubmit () {
            this.$router.back()
            this.$store.dispatch("delView", this.$route);
        },
        // 点击markdown中的图片放大预览
        handleMarkdownClick (e) {
            if (e.target.tagName === 'IMG') {
                // 收集markdown中所有图片
                const container = e.currentTarget
                const imgs = container.querySelectorAll('img')
                const imgList = Array.from(imgs).map(img => img.src)
                const clickedIndex = imgList.indexOf(e.target.src)
                this.previewList = imgList
                this.showIndex = clickedIndex >= 0 ? clickedIndex : 0
                this.showPreviewImg = true
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .el-card__body::-webkit-scrollbar {
	display: block !important; 
}
.status-bar {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;

    .status-item {
        margin-right: 40px;
        line-height: 22px;

        .status-label {
            color: #999;
            margin-right: 8px;
        }

        .status-value {
            font-weight: 600;

            &.status-processing {
                color: #E6A23C;
            }
            &.status-success {
                color: #67C23A;
            }
            &.status-error {
                color: #F56C6C;
            }
        }
    }
}

.status-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    color: #999;
    font-size: 14px;

    i {
        font-size: 20px;
        margin-right: 8px;
    }

    &.error {
        color: #F56C6C;
    }
}

.markdown-body {
    font-size: 14px;
    line-height: 1.8;
    color: #333;

    ::v-deep h1, ::v-deep h2, ::v-deep h3, ::v-deep h4, ::v-deep h5, ::v-deep h6 {
        margin-top: 16px;
        margin-bottom: 12px;
        font-weight: 600;
        line-height: 1.4;
        color: #303133;
    }

    ::v-deep h1 { font-size: 22px; border-bottom: 1px solid #eee; padding-bottom: 8px; }
    ::v-deep h2 { font-size: 20px; border-bottom: 1px solid #eee; padding-bottom: 6px; }
    ::v-deep h3 { font-size: 18px; }
    ::v-deep h4 { font-size: 16px; }
    ::v-deep h5 { font-size: 15px; }
    ::v-deep h6 { font-size: 14px; }

    ::v-deep p {
        margin: 8px 0;
    }

    ::v-deep ul, ::v-deep ol {
        padding-left: 24px;
        margin: 8px 0;
    }

    ::v-deep li {
        margin: 4px 0;
    }

    ::v-deep code {
        background-color: #f5f7fa;
        padding: 2px 6px;
        border-radius: 3px;
        font-family: Consolas, Monaco, monospace;
        font-size: 13px;
        color: #e83e8c;
    }

    ::v-deep pre {
        background-color: #f5f7fa;
        padding: 12px 16px;
        border-radius: 4px;
        overflow-x: auto;
        margin: 12px 0;

        code {
            background-color: transparent;
            padding: 0;
            color: #333;
        }
    }

    ::v-deep blockquote {
        border-left: 4px solid #dcdfe6;
        padding-left: 12px;
        margin: 12px 0;
        color: #606266;
    }

    ::v-deep table {
        border-collapse: collapse;
        width: 100%;
        margin: 12px 0;

        th, td {
            border: 1px solid #dcdfe6;
            padding: 8px 12px;
            text-align: left;
        }

        th {
            background-color: #f5f7fa;
            font-weight: 600;
        }

        tr:nth-child(even) {
            background-color: #fafafa;
        }
    }

    ::v-deep a {
        color: #409EFF;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    ::v-deep hr {
        border: none;
        border-top: 1px solid #e0e0e0;
        margin: 16px 0;
    }

    ::v-deep img {
        max-width: 100%;
        display: inline-block;
        max-height: 160px;
        width: auto;
        cursor: pointer;
        border-radius: 4px;
        border: 1px solid #e0e0e0;
        transition: transform 0.2s, box-shadow 0.2s;

        &:hover {
            transform: scale(1.02);
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
        }
    }
}
</style>